export default "__VITE_ASSET__Dhcb5u8w__"